export default {"src":"/_next/static/media/close-dark-new.9e6d0c26.svg","height":22,"width":22};